import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';
import Box from '@mui/material/Box';
import { useGetCardsQuery } from '../../features/cards/api/cards-api';
import CardsBoardItem from './components/CardsBoardItem';

const CardsBoard = () => {
    const { data, error, isLoading, refetch, isUninitialized, isFetching } = useGetCardsQuery();

    if (isLoading || isUninitialized || isFetching) {
        return <CircularProgress />;
    }

    if (error) {
        return <Button variant="contained" onClick={refetch}>
            Retry
        </Button>;
    }

    const activeItems = data?.items?.filter((item) => item.enabled && item.audio !== undefined);

    return (
        <>
            <Box sx={{ display: 'flex', mb: 1 }}>
                <IconButton onClick={refetch} loading={isLoading}>
                    <RefreshIcon />
                </IconButton>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    '& > :not(style)': {
                        m: 1,
                        width: 256,
                        height: 256,
                    },
                }}
            >
                {activeItems.map((card) => (
                    <CardsBoardItem key={card.id} card={card} />
                ))}
            </Box>
        </>
    );


};

export default CardsBoard;